module.exports = __webpack_public_path__ + "static/media/sign-in-background.3a6f6779.jpeg";